/* =====================================================================
   Feminine Whisper Private Club - Cart Membership Bump + Clean Summary (v4)
   DF-Style: kein Discount-Feld, kein "Estimated total", Total im
   Checkout-Button ("Check out - $99.82"), eine Trust-Zeile, Payment-Logos.
   Alle Sonderzeichen als ASCII HTML-Entities.
   ===================================================================== */
(function () {
  "use strict";

  var CONFIG = {
    variantId: 54833964810567,
    sellingPlanId: 692136444231,
    qualifyingVariantIds: [],
    marker: "_fw_membership",
    bumpTitle: "Add the Private Club",
    bumpSub: "14 days free, then $29/mo &middot; cancel anytime",
    trustLine: "&#128274; Secure checkout &nbsp;&middot;&nbsp; 30-day money-back guarantee"
  };

  /* echte Payment-Logos (kompakte inline-SVGs) */
  var PAY = [
    '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="23" rx="3.5" fill="#fff" stroke="#E6E6E6"/><text x="18" y="16" font-family="Arial,Helvetica,sans-serif" font-size="10" font-weight="700" font-style="italic" fill="#1A1F71" text-anchor="middle" letter-spacing="0.5">VISA</text></svg>',
    '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="23" rx="3.5" fill="#fff" stroke="#E6E6E6"/><circle cx="15" cy="12" r="6" fill="#EB001B"/><circle cx="21" cy="12" r="6" fill="#F79E1B" fill-opacity=".9"/></svg>',
    '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="23" rx="3.5" fill="#1F72CD"/><text x="18" y="15.5" font-family="Arial,Helvetica,sans-serif" font-size="8" font-weight="700" fill="#fff" text-anchor="middle" letter-spacing="0.3">AMEX</text></svg>',
    '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="23" rx="3.5" fill="#fff" stroke="#E6E6E6"/><text x="18" y="15.5" font-family="Arial,Helvetica,sans-serif" font-size="9" font-weight="700" text-anchor="middle"><tspan fill="#003087">Pay</tspan><tspan fill="#009CDE">Pal</tspan></text></svg>',
    '<svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="35" height="23" rx="3.5" fill="#000"/><path d="M11.4 8.3c.34-.42.57-.99.5-1.57-.49.02-1.09.33-1.44.75-.31.36-.59.95-.51 1.5.55.05 1.1-.28 1.45-.68z" fill="#fff"/><path d="M11.9 9.1c-.8-.05-1.48.45-1.86.45-.39 0-.97-.43-1.6-.42-.82.01-1.58.48-2 1.22-.85 1.48-.22 3.67.61 4.87.41.59.89 1.25 1.53 1.23.61-.02.85-.4 1.59-.4.74 0 .95.4 1.6.39.66-.01 1.08-.6 1.48-1.19.47-.68.66-1.34.67-1.38-.01-.01-1.29-.5-1.3-1.97-.01-1.23 1-1.82 1.05-1.85-.57-.85-1.47-.94-1.78-.96z" fill="#fff"/><text x="24" y="15.5" font-family="Arial,Helvetica,sans-serif" font-size="8.5" font-weight="600" fill="#fff" text-anchor="middle">Pay</text></svg>',
    '<svg width="46" height="24" viewBox="0 0 46 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x=".5" y=".5" width="45" height="23" rx="3.5" fill="#5A31F4"/><text x="23" y="15.5" font-family="Arial,Helvetica,sans-serif" font-size="8" font-weight="700" fill="#fff" text-anchor="middle">shop Pay</text></svg>'
  ];

  var writeChain = Promise.resolve(), selfCall = false, lastCart = null;
  var optout = function(){ try { return sessionStorage.getItem("fw_optout")==="1"; } catch(e){ return false; } };
  var setOptout = function(v){ try { v?sessionStorage.setItem("fw_optout","1"):sessionStorage.removeItem("fw_optout"); } catch(e){} };
  function queue(fn){ writeChain=writeChain.then(fn,fn); return writeChain; }

  function getCart(){ selfCall=true; return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json();}).then(function(c){lastCart=c;return c;}).finally(function(){selfCall=false;}); }
  function findLine(c){ return (c&&c.items||[]).find(function(li){ return li.id===CONFIG.variantId && ((li.properties&&li.properties[CONFIG.marker]==="true")||li.selling_plan_allocation); }); }
  function qualifies(c){ var o=(c&&c.items||[]).filter(function(li){return li.id!==CONFIG.variantId;}); if(!o.length) return false; if(!CONFIG.qualifyingVariantIds.length) return true; return o.some(function(li){return CONFIG.qualifyingVariantIds.indexOf(li.id)!==-1;}); }
  function cartWrite(u,b){ selfCall=true; return fetch(u,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(b)}).then(function(r){return r.json();}).finally(function(){selfCall=false;}); }
  function add(){ var p={}; p[CONFIG.marker]="true"; return cartWrite("/cart/add.js",{items:[{id:CONFIG.variantId,quantity:1,selling_plan:CONFIG.sellingPlanId,properties:p}]}); }
  function remove(l){ return cartWrite("/cart/change.js",{id:l.key,quantity:0}); }
  function setQty(l,q){ return cartWrite("/cart/change.js",{id:l.key,quantity:q}); }

  function ensure(on){
    return queue(function(){
      return getCart().then(function(cart){
        var line=findLine(cart), want=on&&!optout()&&qualifies(cart), p;
        if(want&&!line) p=add();
        else if(!want&&line) p=remove(line);
        else if(line&&line.quantity>1) p=setQty(line,1);
        else p=Promise.resolve();
        return p.then(getCart).then(function(fresh){ render(fresh); return fresh; });
      }).catch(function(e){ console.warn("[FW club]",e); });
    });
  }

  /* ---------- kompakter Membership-Bump ---------- */
  function buildBump(){
    var w=document.createElement("div");
    w.id="fw-club-bump";
    w.style.cssText="display:flex;align-items:center;gap:12px;padding:12px 0;margin:0;border-top:1px solid rgba(0,0,0,.08);font-family:inherit;";
    w.innerHTML=
      '<label style="position:relative;display:inline-block;width:42px;height:24px;flex:0 0 auto">'+
        '<input type="checkbox" id="fw-club-toggle" style="opacity:0;width:0;height:0">'+
        '<span id="fw-club-track" style="position:absolute;inset:0;background:#c9bfa9;border-radius:24px;transition:.2s;cursor:pointer"></span>'+
        '<span id="fw-club-knob" style="position:absolute;left:3px;top:3px;width:18px;height:18px;background:#fff;border-radius:50%;transition:.2s;pointer-events:none"></span>'+
      '</label>'+
      '<div style="flex:1;min-width:0;line-height:1.3">'+
        '<div style="font-size:13px;font-weight:600;color:#1a1a1a">'+CONFIG.bumpTitle+
          ' <span style="font-size:10px;font-weight:700;color:#8a7a55;letter-spacing:.3px">&middot; 14 DAYS FREE</span></div>'+
        '<div style="font-size:11px;color:#8a8178;margin-top:1px">'+CONFIG.bumpSub+'</div>'+
      '</div>';
    w.querySelector("#fw-club-toggle").addEventListener("change",function(e){
      e.target.disabled=true; setOptout(!e.target.checked);
      ensure(e.target.checked).finally(function(){ e.target.disabled=false; });
    });
    return w;
  }
  function paint(on){
    var t=document.getElementById("fw-club-track"), k=document.getElementById("fw-club-knob"), c=document.getElementById("fw-club-toggle");
    if(!t||!k||!c) return;
    c.checked=on; t.style.background=on?"#8a7a55":"#c9bfa9"; k.style.left=on?"21px":"3px";
  }

  /* ---------- Trust + Payment-Logos ---------- */
  function buildTrust(){
    var t=document.createElement("div");
    t.id="fw-trust";
    t.style.cssText="padding:12px 0 2px;text-align:center;font-family:inherit;";
    t.innerHTML=
      '<div style="font-size:11.5px;color:#8a8178;letter-spacing:.2px;white-space:nowrap;overflow:hidden">'+CONFIG.trustLine+'</div>'+
      '<div style="display:flex;gap:6px;justify-content:center;align-items:center;flex-wrap:wrap;margin-top:9px">'+PAY.join('')+'</div>';
    return t;
  }

  /* ---------- injizierte Styles: kompakte Items, ein CTA ---------- */
  function injectCss(){
    if(document.getElementById("fw-cart-css")) return;
    var st=document.createElement("style");
    st.id="fw-cart-css";
    st.textContent=
      /* kompakte Line-Items */
      ".cart-drawer__items .cart-items__table-row > td{padding-block:10px;}"+
      ".cart-drawer__items .cart-items__details{font-size:14px;line-height:1.35;}"+
      ".cart-drawer__items .cart-items__details a{font-size:14px;}"+
      ".cart-drawer__items .cart-items__details p,.cart-drawer__items .cart-items__details span{font-size:12px;}"+
      ".cart-drawer__items .cart-items__media{width:56px;min-width:56px;}"+
      ".cart-drawer__items .cart-items__media img{width:56px;height:auto;}"+
      ".cart-drawer__items .cart-items__price{font-size:14px;}"+
      ".cart-drawer__items .cart-items__quantity{transform:scale(.8);transform-origin:left center;}"+
      ".cart-drawer__items{padding-top:0;}"+
      ".cart-drawer__header{padding-bottom:4px;}"+
      /* EIN primaerer CTA: Wallet-Duplikate + Abo-Disclaimer raus (Checkout zeigt beides) */
      ".cart-drawer__summary additional-checkout-buttons,"+
      ".cart-drawer__summary .additional-checkout-buttons,"+
      ".cart__ctas .dynamic-checkout__content,"+
      ".cart__ctas small{display:none !important;}"+
      /* Membership-Zeile: kein Mengen-Stepper */
      "tr.fw-mem-row .cart-items__quantity{display:none !important;}";
    document.head.appendChild(st);
  }

  /* Membership-Zeile taggen + Selling-Plan-Text freundlich machen */
  function polishItems(){
    document.querySelectorAll(".cart-items__table-row").forEach(function(tr){
      if(tr.querySelector('a[href*="private-club"]')){
        tr.classList.add("fw-mem-row");
        tr.querySelectorAll(".cart-items__details *").forEach(function(n){
          if(n.children.length===0 && /monthly subscription/i.test(n.textContent)) n.textContent="14-day free access";
        });
      }
    });
  }

  /* ---------- Summary aufraeumen (DF-Style) ---------- */
  function hideEl(el){ if(el && el.style.display!=="none") el.style.display="none"; }
  function money(cents){ return "$"+(cents/100).toFixed(2); }
  function cleanSummary(cart){
    /* Drawer-Footer kompakt: leere Totals-Box raus, Flex-Gap verkleinern */
    var ds=document.querySelector(".cart-drawer__summary");
    if(ds){
      if(ds.style.gap!=="14px") ds.style.gap="14px";
      hideEl(ds.querySelector(".cart__summary-totals"));
    }
    /* Discount-Accordion weg (Coupon-Leak) */
    document.querySelectorAll(".cart-discount").forEach(hideEl);
    /* "Estimated total"-Zeile weg */
    document.querySelectorAll(".cart__summary-item.cart__total").forEach(hideEl);
    /* Steuer-/Versand-Hinweis weg (digitales Produkt) */
    document.querySelectorAll(".cart__summary-item.tax-note, .tax-note").forEach(hideEl);
    /* Total in den Checkout-Button: "Check out  -  $99.82" */
    if(cart && typeof cart.total_price==="number"){
      var btn=document.querySelector("button.cart__checkout-button, .cart__checkout-button");
      if(btn){
        var current=(btn.textContent||"").replace(/\s+/g," ").trim();
        var target=("Check out "+String.fromCharCode(8226)+" "+money(cart.total_price));
        if(current!==target){
          btn.innerHTML='Check out &nbsp;&bull;&nbsp; '+money(cart.total_price);
        }
      }
    }
  }

  /* ---------- Platzierung ---------- */
  function summaryEl(){
    var s=document.querySelector(".cart-drawer__summary")||document.querySelector(".cart__summary-totals");
    if(s) return s;
    var co=document.querySelector('button[name="checkout"],.cart__checkout-button');
    return co ? (co.closest(".cart-drawer__footer,form")||co.parentNode) : null;
  }
  function placeBump(w){
    var s=summaryEl(); if(!s) return false;
    if(w.parentNode!==s || s.firstChild!==w){ s.insertBefore(w, s.firstChild); }
    return true;
  }
  function placeTrust(){
    if(document.getElementById("fw-trust")) return;
    var co=document.querySelector('button[name="checkout"],.cart__checkout-button');
    var anchor=co?(co.closest(".cart__checkout-button-wrapper")||co):null;
    if(anchor&&anchor.parentNode){ anchor.parentNode.insertBefore(buildTrust(), anchor.nextSibling); }
    else { var s=summaryEl(); if(s) s.appendChild(buildTrust()); }
  }

  function render(cart){
    cart=cart||lastCart;
    injectCss();
    var w=document.getElementById("fw-club-bump");
    if(!w) w=buildBump();
    if(!placeBump(w)) return;
    if(cart) paint(!!findLine(cart));
    placeTrust();
    cleanSummary(cart);
    polishItems();
  }

  /* ---------- Cart-Beobachtung ---------- */
  var scheduled=false;
  function scheduleEnsure(){ if(scheduled) return; scheduled=true; setTimeout(function(){ scheduled=false; ensure(true); },300); }
  function isCartMutation(u){ return typeof u==="string" && /\/cart\/(add|change|update|clear)(\.js)?/.test(u); }
  var _fetch=window.fetch;
  window.fetch=function(input){ var url=(typeof input==="string")?input:(input&&input.url)||""; var s=selfCall; return _fetch.apply(this,arguments).then(function(res){ if(!s&&isCartMutation(url)) scheduleEnsure(); return res; }); };
  var _open=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,url){ this.__fwUrl=url; return _open.apply(this,arguments); };
  var _send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send=function(){ var self=this,s=selfCall; this.addEventListener("load",function(){ if(!s&&isCartMutation(self.__fwUrl)) scheduleEnsure(); }); return _send.apply(this,arguments); };

  var moT=null;
  new MutationObserver(function(){ if(moT) return; moT=setTimeout(function(){ moT=null; render(lastCart); },200); })
    .observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:["class","open","aria-hidden","style"]});

  function boot(){ ensure(true); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",boot); else boot();
})();
